/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOdometer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.375 11.22 1.249 1.561-2.79 2.233A3.004 3.004 0 0 1 12 19c-1.654 0-3-1.346-3-3s1.346-3 3-3c.58 0 1.124.166 1.584.453zM12 15a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm0-9c5.429 0 9.848 4.327 9.996 9.72L22 16h-2a8 8 0 0 0-15.996-.25L4 16H2C2 10.477 6.477 6 12 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOdometer as Odometer };
